import React from "react";
import {
  Grid,
  Stack,
  Typography,
  Box,
} from "@mui/material";
import service from "./../images/service.jpeg";
import market from "./../images/market.jpeg";
import sales from "./../images/sales.jpeg";
import customer from "./../images/customer.jpeg";
import capacity from "./../images/capacity.jpeg";

import useMediaQuery from "@mui/material/useMediaQuery";

const CrmApp = () => {
  const vMediaQuery = useMediaQuery("(max-width:600px)");

  const costStyle = {
    flexGlow: 1,
    padding: vMediaQuery ? "20px" : "50px 140px",
    backgroundColor: "#357ec7",
    textAlign: "center",
  };

  return (
    <Box sx={costStyle}>
      <h1 style={{ color: "white", fontSize: vMediaQuery ? "20px" : "34px" }}>
        Explore Microsoft Dynamics 365{" "}
        <strong style={{ color: "#a5d136" }}>CRM Applications</strong>
      </h1>
      <Typography
        variant={vMediaQuery ? "body2" : "subtitle1"}
        sx={{ color: "white" }}
      >
        Get access to cutting edge technology at a whopping 50% less cost
        compared to other options with {vMediaQuery || <br />}
        GDR Consultancy Services. With no usage level commitments and
        flexibility to scale up or down, ODS has become a{" "}
        {vMediaQuery || <br />} preferred choice as 98.7% of our customers found
        GDR Consultancy Services highly beneficial.
      </Typography>
      <Grid
        container
        spacing={0}
        sx={{ padding: vMediaQuery ? "0px" : "0px 40px" }}
      >
        <Grid item xs={6} md={4} lg={2.4}>
          <Stack>
            <div className="values-contanierLCQ">
              <img className="valuesLCQ" alt="certificates" src={sales} />
            </div>
            <Typography
              variant="body2"
              sx={{ marginTop: vMediaQuery ? "17px" : "24px", color: "white", fontSize: vMediaQuery ? "14px" : "17px" }}
            >
              <strong>
                Dynamics 365 <br /> Sales
              </strong>
            </Typography>
          </Stack>
        </Grid>
        <Grid item xs={6} md={4} lg={2.4}>
          <Stack>
            <div className="cost-contanierLCQ">
              <img className="costLCQ" alt="certificates" src={service} />
            </div>
            <Typography
              variant="body2"
              sx={{ marginTop: vMediaQuery ? "17px" : "26px", color: "white", fontSize: vMediaQuery ? "14px" : "17px" }}
            >
              <strong>
                Dynamics 365 <br /> Field Service
              </strong>
            </Typography>
          </Stack>
        </Grid>
        <Grid item xs={6} md={4} lg={2.4}>
          <Stack>
            <div className="values-contanierLCQ">
              <img className="valuesLCQ" alt="certificates" src={customer} />
            </div>
            <Typography
              variant="body2"
              sx={{ marginTop: vMediaQuery ? "17px" : "26px", color: "white", fontSize: vMediaQuery ? "14px" : "17px" }}
            >
              <strong>
                Dynamics 365 <br />
                Customer Service{" "}
              </strong>
            </Typography>
          </Stack>
        </Grid>
        <Grid item xs={6} md={4} lg={2.4}>
          <Stack>
            <div className="costScalable-contanierLCQ">
              <img className="crmScalable" alt="certificates" src={market} />
            </div>
            <Typography
              variant="body2"
              sx={{ marginTop: vMediaQuery ? "10px" : "26px", color: "white", fontSize: vMediaQuery ? "14px" : "17px" }}
            >
              <strong>
                Dynamics 365 <br /> Marketing{" "}
              </strong>
            </Typography>
          </Stack>
        </Grid>
        <Grid item xs={6} md={4} lg={2.4}>
          <Stack>
            <div className="values-contanierQ">
              <img className="crmCap" alt="certificates" src={capacity} />
            </div>
            <Typography
              variant="body2"
              sx={{ marginTop: vMediaQuery ? "17px" : "26px", color: "white", fontSize: vMediaQuery ? "14px" : "17px" }}
            >
              <strong>
                Dynamics 365 Customer <br /> Insights Capacity
              </strong>
            </Typography>
          </Stack>
        </Grid>
      </Grid>
    </Box>
  );
};

export default CrmApp;
